import React, { useMemo, useState } from 'react';
import _ from 'underscore';
import { SharedFile } from '../types/shared-folder.type';
import FileList from './file-list';
import SearchFiles from './search-files';

type Props = {
  fileList: SharedFile[] | undefined;
  isLoading: boolean;
};

const FileView: React.FC<Props> = ({ fileList, isLoading }) => {
  const [searchValue, setSearchValue] = useState<string>('');

  //#region renders

  const renderFiles = useMemo(() => {
    const rows = _.chain(fileList)
      .filter((showFiles) => showFiles.name?.toLowerCase().includes(searchValue.toLowerCase()))
      .value();

    return rows.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
  }, [searchValue, fileList]);

  //#endregion renders

  return (
    <>
      <SearchFiles search={{ searchValue, setSearchValue }} resultLength={renderFiles.length} />
      <FileList files={renderFiles} isLoading={isLoading} />
    </>
  );
};

export default React.memo(FileView);
